import React, {useEffect} from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes  } from 'react-router-dom';
import AlphabeticalSorter from './components/AlphabeticalOrderSorter';
import AlternatingCaps from './components/AlternatingCapsGenerator';
import CaseConverter from './components/ConverttoLowercase';
import FakeWordGenerators from './components/FakeWordGenerator';
import FancyTextGenerators from './components/FancyTextGenerator';
import ReplaceTextTool from './components/FindandReplaceText'
import ItalicGenerator from './components/ItalicsTextGenerator'
import MirrorTextGenerators from './components/MirrorTextGenerator'
import MorseCodeTranslators from './components/MorseCodeTranslator'
import NumberSort from './components/NumberSorter'
import IPAddressGenerator from './components/RandomIPAddress'
import DuplicateLineRemover from './components/RemoveDuplicateLines'
import ReverseTextGenerator from './components/ReverseText'
import WhitespaceRemover from './components/RemoveWhitespace'
import JsonStringifyTextGenerator from './components/Jsonstringifytext'
// import RomanNumeralDateConverter from './components/RomanNumeralDate'
import RepeatTextTool from './components/TextRepeater'
import WideTextGenerators from './components/WideTextGenerator'
import Utf8EncoderDecoder from './components/UTFEncoderDecoder'
import SentenceCounters from './components/SentenceCounter'
import SuperscriptGenerators from './components/SuperscriptGenerator'
import UpsideDownTextGenerator from './components/UpsideDownText'
import NatoAlphabetTranslator from './components/NATOPhoneticAlphabetTranslator'
import BinaryCodeTranslator from './components/BinaryCodeTranslator'
import StrikethroughTextConverter from './components/StrikethroughText'
import CaseConverters from './components/InvertTextCase'
import UnicodeTextConverters from './components/UnicodeTextConverter'
import CursedTextGenerators from './components/CursedTextGenerator'
import WingdingsConverter from './components/WingdingsTranslator'
import URLTOOLS from './components/URLOpenerTool'
import SmallTextGenerators from './components/SmallTextGenerator'
// import Percentagecals from './components/percentagecalpercal'
import FacebookFontGenerators from './components/FacebookFontGenerator'
import UnderlineConverter from './components/UnderlineTextGenerator'
import TextHexConverter from './components/TextToHexConverter'
import InvisibleText from './components/InvisibleTextGenerator'
import BoldTextConverter from './components/BoldtextGenerator'
import CSVJSONConverter from './components/CSVToJSONConverter'
import BubbleText from './components/BubbleTextGenerator'
import SlugifyUrlGenerator from './components/Sluggenerator'
import PasswordGenerator from './components/PasswordGenerator'
import ZalgoGlitchGenerator from './components/ZalgoGlitchGenerator'
import UnzalgoTextGenerator from './components/UnzalgoTextGenerator'
import WeirdTextGenerator from './components/WeirdTextGenerator'

import 'bootstrap/dist/css/bootstrap.css';




function App() {


  return (
    <div className="App">
    <Router>
        <Routes >
          <Route path="/alphabetical-order-sorter" element={<AlphabeticalSorter/>} />
          <Route path="/alternating-caps-generator" element={<AlternatingCaps/>} />
          <Route path="/uppercase-and-lowercase-converter" element={<CaseConverter/>} />
          <Route path="/fakeword-generator" element={<FakeWordGenerators/>} />
          <Route path="/find-and-replace-text" element={<ReplaceTextTool/>} />
          <Route path="/italics-text-generator" element={<ItalicGenerator/>} />
          <Route path="/mirror-text-generator" element={<MirrorTextGenerators/>} />
          <Route path="/morse-code-translator" element={<MorseCodeTranslators/>} />
          <Route path="/number-sorter" element={<NumberSort/>} />
          <Route path="/random-ip-address-generator" element={<IPAddressGenerator/>} />
          <Route path="/remove-duplicate-lines" element={<DuplicateLineRemover/>} />
          <Route path="/reverse-text-generator" element={<ReverseTextGenerator/>} />
          <Route path="/remove-white-space" element={<WhitespaceRemover/>} />
          <Route path="/multiple-urls-opener" element={<URLTOOLS/>} />    
          <Route path="/text-repeater" element={<RepeatTextTool/>} />
          <Route path="/wide-text-generator" element={<WideTextGenerators/>} />
          <Route path="/utf8-encoder-decoder" element={<Utf8EncoderDecoder/>} />
          <Route path="/sentence-counter" element={<SentenceCounters/>} />
          <Route path="/superscript-generator" element={<SuperscriptGenerators/>} />
          <Route path="/upside-down-text-generator" element={<UpsideDownTextGenerator/>} />
          <Route path="/binary-code-translator" element={<BinaryCodeTranslator/>} />
          <Route path="/slug-generator" element={<SlugifyUrlGenerator/>} />
          <Route path="/invert-text-case-converter" element={<CaseConverters/>} />
          <Route path="/strikethrough-text-generator" element={<StrikethroughTextConverter/>} />  
          <Route path="/fancy-text-generator" element={<FancyTextGenerators/>} />  
          <Route path="/json-stringify-text-generator" element={<JsonStringifyTextGenerator/>} />  
          <Route path="/uni-code-text-converter" element={<UnicodeTextConverters/>} /> 
          <Route path="/cursed-text-generator" element={<CursedTextGenerators/>} /> 
          <Route path="/wingdings-translator" element={<WingdingsConverter/>} /> 
          <Route path="/small-text-generator" element={<SmallTextGenerators/>} /> 
          <Route path="/facebook-font-generator" element={<FacebookFontGenerators/>} />
          <Route path="/text-convertor" element={<UnderlineConverter/>} />  
          <Route path="/text-to-hex" element={<TextHexConverter/>} />  
          <Route path="/invisible-text-generator" element={<InvisibleText/>} />  
          <Route path="/bold-text-generator" element={<BoldTextConverter/>} />  
          <Route path="/csv-to-json-converter" element={<CSVJSONConverter/>} />  
          <Route path="/bubble-text-generator" element={<BubbleText/>} />  
          <Route path="/nato-phonetic-alphabet-translator" element={<NatoAlphabetTranslator/>} />
          <Route path="/password-generator" element={<PasswordGenerator/>} />
          <Route path="/zalgo-glitch-generator" element={<ZalgoGlitchGenerator/>} />
          <Route path="/unzalgo-text-generator" element={<UnzalgoTextGenerator/>} />
          <Route path="/weird-text-generator" element={<WeirdTextGenerator/>} />

          
        </Routes >
     </Router>
    
    </div> 
  );
}
export default App;
